import { jsx as _jsx } from "react/jsx-runtime";
import { addSlideUpAnimation } from '../../common/add-slide-up-animation';
import { mountComponentByClassWithData } from '../../common/mount-helpers';
import { Gallery } from '../../components/gallery';
import { ListingsCarousel } from '../../components/listings-carousel';
document.addEventListener('DOMContentLoaded', () => {
    addSlideUpAnimation('.slide-up-animation-section');
    mountComponentByClassWithData('listing-gallery', (props) => _jsx(Gallery, { ...props }));
    mountComponentByClassWithData('related-listings-wrapper', (props) => _jsx(ListingsCarousel, { ...props }));
});
